import { settingsAtom } from "core/shared";

type CurrencyProps = {
  code?: string;
  symbol?: string;
};

type OptionsProps = {
  withSymbol?: boolean;
  withCode?: boolean;
  showZero?: boolean; // show price if 0 (default false)
  minFrac?: number;
  maxFrac?: number;
  currency?: CurrencyProps;
};

export function price(price?: number | null, options: OptionsProps = {}) {
  // Handle missing value & showZero logic
  if (
    price === undefined ||
    price === null ||
    (price === 0 && !options.showZero)
  ) {
    return "";
  }

  if (price === 0 && options.showZero) {
    return "free";
  }

  // Only one of withSymbol or withCode should be true, never both.
  const withCode = !!options.withCode;
  let withSymbol = !!options.withSymbol;

  if (withSymbol && withCode) {
    // Prefer withSymbol if both are true, ignore withCode
    withSymbol = false;
  }
  if (!withSymbol && !withCode) {
    // Default to withSymbol = true if neither specified
    withSymbol = true;
  }

  // Accept a "currency" in options, or fallback
  const baseCurrency = settingsAtom.get("general")?.baseCurrency;
  const currencyObj: CurrencyProps = options.currency || baseCurrency || {};
  const currencyCode = currencyObj.code || "USD";
  const currencySymbol = currencyObj.symbol || "$";

  const minFrac = options.minFrac ?? 0;
  const maxFrac = options.maxFrac ?? 2;

  const formattedPrice = price.toLocaleString(undefined, {
    minimumFractionDigits: minFrac,
    maximumFractionDigits: maxFrac,
  });

  if (withSymbol) {
    // "$10.00"
    return `${currencySymbol}${formattedPrice}`;
  } else if (withCode) {
    // "10.00 USD"
    return `${formattedPrice} ${currencyCode}`;
  }

  // Should never reach here, fallback
  return formattedPrice;
}
